import React, { useEffect, useState } from 'react'

import styled, { css } from 'styled-components'

import { shapeScaleIn, shapeScaleOut } from './animations'
import { ShapeIcon } from './Shapes'
import { getLoadingGroup, getRandomShape } from './utils'

const GiftShapeContainer = styled.div<{
  index: number
  isVisible: boolean
}>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isVisible }) =>
    isVisible
      ? css`
          animation: ${shapeScaleOut} 0.3s cubic-bezier(0.55, -0.21, 0.14, 1.24);
          animation-fill-mode: forwards;
        `
      : css`
          animation: ${shapeScaleIn} 0.3s cubic-bezier(0.31, 0.02, 0.22, 1.76);
          animation-fill-mode: forwards;
        `}
`

const StyledIconContainer = styled.div<{ shape?: string; isFlipped?: boolean }>`
  ${({ shape }) =>
    !shape &&
    css`
      cursor: pointer;
    `};
  ${({ shape, isFlipped }) =>
    shape === 'triangle' &&
    isFlipped &&
    css`
      transform: rotate(180deg);
    `}
  ${({ shape, isFlipped }) =>
    shape === 'rectangle' &&
    isFlipped &&
    css`
      transform: scaleY(-1);
    `}
`

export const GiftShape = ({
  index,
  color,
  isFlipped,
  shape,
}: {
  index: number
  color: string
  isFlipped: boolean
  shape: string
}): React.ReactElement => {
  const [isVisible, setIsVisible] = useState(true)
  const [giftProperties, setGiftProperties] = useState({
    color,
    isFlipped,
    shape,
  })

  const handleClick = () => {
    setIsVisible(true)

    setTimeout(() => {
      setGiftProperties(getRandomShape())
      setIsVisible(false)
    }, 400)
  }

  useEffect(() => {
    setTimeout(
      () => {
        setIsVisible(false)
      },
      getLoadingGroup(index) * 100,
    )
  }, [giftProperties, index])

  return (
    <GiftShapeContainer
      key={`gift-shape-${index}`}
      index={index}
      isVisible={isVisible}
    >
      <StyledIconContainer
        shape={giftProperties.shape}
        isFlipped={giftProperties.isFlipped}
        onClick={handleClick}
      >
        {ShapeIcon(giftProperties.shape, giftProperties.color)}
      </StyledIconContainer>
    </GiftShapeContainer>
  )
}
